import React, { Component } from 'react';

import BackgroundSlideshow from 'react-background-slideshow'
import {Image, Transformation, CloudinaryContext} from 'cloudinary-react';

import scrollToElement from 'scroll-to-element';

class HomeCarousel extends Component {
    
    constructor(){
        super()

        this.scrollHandle = this.scrollHandle.bind();
    }

    scrollHandle() {
        scrollToElement('.scroll-stop');
    }

    render() {
        let images = [
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/14.jpg',
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/4.jpg',
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/5.jpg',
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/6.jpg',
        ]
        
		return (
			<section className="carousel">

                <BackgroundSlideshow images={images} animationDelay={4000}  disableClick={ () => { alert(); } } disableInterval={ () => { alert(); } }/>
 
                <div className="container">
                    <div className="table-wrapper">
                        <div className="table-cell">
                            <h2>Ultimate Bike Store</h2>
                            <p>Velkommen til en ny verden af cykler, fordi vi gør forskel <br />Vi leverer cykler i storkøbenhavn fra 200 DKK</p>
                            <span className="pe-7s-angle-down-circle" onClick={this.scrollHandle}></span>
                        </div>
                    </div>
                </div>
            </section>
		);
	}
}

export default HomeCarousel;



// WEBPACK FOOTER //
// ./src/Components/HomeCarousel.js